var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSjNordLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 36,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E24152",
    fillRule: "evenodd",
    d: "m27.34 19.711-7.398 7.34c-.75.77-1.336 1.38-1.6 2.537l-.372 1.453-.371-1.453c-.265-1.157-.85-1.766-1.6-2.537L8.6 19.71c-.777-.745-1.387-1.321-2.552-1.584l-1.465-.368 1.465-.369c1.165-.262 1.775-.838 2.552-1.584l9.374-9.3 9.366 9.292c.777.745 1.392 1.33 2.561 1.592l1.465.369-1.465.368c-1.174.258-1.788.839-2.56 1.584ZM20.241 2.257l-2.275 4.244V0L.067 17.759l17.899 17.758L35.865 17.76 20.24 2.257Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.067 0H36.37v36H.067z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSjNordLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sj_nord_logo.2739c6d3ee31950e54dcf90369a75d98.svg";